export default function() {
  return process.env.REACT_APP_NODE_ENV === 'development' ? 'include' : 'same-origin'
}